// src/pages/SarpanchKaryalaya.js
import React from "react";

const Sarpanch = () => {
  

  return (
    <div style={styles.container}>
      {/* ===== Header ===== */}
      <header style={styles.header}>
        <div style={styles.logo}>
          <div style={styles.logoCircle}>GP</div>
        </div>
        <div style={styles.title}>
          <h1 style={styles.mainTitle}> ग्रामपंचायत घोणसई - मेट 
</h1>
          <p style={styles.subTitle}>पंचायत समिती वाडा| जिल्हा परिषद पालघर</p>
          
        </div>
      </header>

      {/* ===== सरपंच प्रोफाईल (फोटोसह) ===== */}
      <section style={styles.profileSection}>
        <div style={styles.profileCard}>
          {/* फोटो जोडला */}
          <div style={styles.photoContainer}>
            <img
              src={`${process.env.PUBLIC_URL}/images/sarpanchh.jpeg`}
              alt="सन्माननीय सरपंच सौ. शैला राजेश जाबर"
              
              style={styles.sarpanchPhoto}
            />
          </div>
          <div style={styles.profileInfo}>
            <h2 style={styles.sarpanchName}>
              सन्माननीय सरपंच: सौ. शैला राजेश जाबर
              
            </h2>
            <p style={styles.motto}>
              <strong>‘प्रत्येक नागरिकाच्या आवाजाला महत्त्व’</strong>
              <h6>phone no :8080658326</h6>
            </p>
          </div>
        </div>
      </section>

      {/* ===== संदेश ===== */}
      <section style={styles.messageSection}>
        <h3 style={styles.sectionTitle}>सरपंचांचा संदेश</h3>
        <p style={styles.message}>
          मी, <strong>सौ. शैला राजेश जाबर</strong>, ग्रामपंचायत घोणसई - मेट
 नेतृत्वाची जबाबदारी स्वीकारताना हे सुनिश्चित केले आहे की, ग्रामपंचायतीचे दरवाजे{" "}
          <strong>प्रत्येक सामान्य नागरिकासाठी खुले</strong> असतील. माझ्या नेतृत्वाखालील कारभार{" "}
          <em>‘ऑफिस-केंद्रित’</em> नसून, <em>‘जनता-केंद्रित’</em> आहे.
        </p>
      </section>

      {/* ===== यशोगाथा ===== */}
      <section style={styles.successSection}>
        <h3 style={styles.sectionTitle}>आमच्या कारभाराचे यशोगाथा (Success Stories)</h3>
        <p style={styles.intro}>
          आमच्या टीमने गावकऱ्यांच्या सक्रिय सहकार्याने खालील महत्त्वपूर्ण बदल घडवले आहेत:
        </p>
        <div style={styles.successGrid}>
          <div style={styles.successCard}>
            <span style={styles.icon}>💧</span>
            <h4>जबाबदार पाणी व्यवस्थापन</h4>
            <p>
              “पाणी आडवा, पाणी जिरवा” या तत्त्वावर काम करत आम्ही जलसंधारणाचे मोठे काम पूर्ण केले,
              ज्यामुळे भूजल पातळी वाढण्यास मदत झाली.
            </p>
          </div>
          <div style={styles.successCard}>
            <span style={styles.icon}>🌿</span>
            <h4>प्रदूषण नियंत्रण</h4>
            <p>
              गावातील सार्वजनिक ठिकाणी थुंकण्यास बंदी आणि प्लास्टिक वापराचे कठोर नियम लागू केले,
              ज्यामुळे स्वच्छता वाढली.
            </p>
          </div>
          <div style={styles.successCard}>
            <span style={styles.icon}>🕒</span>
            <h4>सुलभ सेवा</h4>
            <p>
              कोणताही दाखला आता जास्तीत जास्त <strong>४८ तासांत</strong> देण्याची प्रक्रिया सुरू केली.
            </p>
          </div>
        </div>
      </section>

      {/* ===== तरुणांसाठी ===== */}
      <section style={styles.youthSection}>
        <h3 style={styles.sectionTitle}>गावातील तरुणांसाठी गुंतवणूक</h3>
        <p style={styles.intro}>
          मी गावाच्या तरुणांना उद्याचे नेते मानतो. त्यांच्या भविष्यासाठी मी विशेष लक्ष दिले आहे:
        </p>
        <div style={styles.youthGrid}>
          <div style={styles.youthCard}>
            <span style={styles.icon}>💻</span>
            <h4>डिजिटल कौशल्ये</h4>
            <p>कॉम्प्युटर प्रशिक्षण वर्ग सुरू करणे आणि त्यांना सरकारी नोकऱ्यांसाठी तयारी करण्यास मदत करणे.</p>
          </div>
          <div style={styles.youthCard}>
            <span style={styles.icon}>🏋️</span>
            <h4>आरोग्य आणि खेळ</h4>
            <p>सार्वजनिक व्यायामशाळा (Open Gym) आणि खेळाचे मैदान विकसित करणे.</p>
          </div>
        </div>
      </section>

      {/* ===== समाप्ती संदेश ===== */}
      <section style={styles.closingSection}>
        <p style={styles.closing}>
          <strong>
             घोणसई - मेट नागरिकांचे प्रेम आणि विश्वास हीच माझ्या कामाची खरी प्रेरणा आहे.
          </strong>
          <br />
          आपण मिळून, आपला विकास निश्चित करूया.
        </p>
      </section>

      {/* ===== फूटर ===== */}
      <footer style={styles.footer}>
        <p>© 2026  ग्रामपंचायत घोणसई - मेट| सर्व हक्क राखीव</p>
        <p>
          वेबसाइट:{" "}
          <a href="https://gpghonsai.in" style={styles.link}>
            gpghonsai.in
          </a>
        </p>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "900px",
    margin: "20px auto",
    padding: "20px",
    background: "#f8fdff",
    border: "2px solid #1e88e5",
    borderRadius: "16px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    color: "#333",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "3px solid #1e88e5",
    paddingBottom: "15px",
    marginBottom: "25px",
  },
  logo: { marginRight: "15px" },
  logoCircle: {
    width: "70px",
    height: "70px",
    background: "#1e88e5",
    color: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "bold",
  },
  title: { flex: 1 },
  mainTitle: { margin: 0, fontSize: "26px", color: "#1e88e5", fontWeight: "bold" },
  subTitle: { margin: "5px 0", fontSize: "16px", color: "#555" },
  timestamp: { margin: "5px 0", fontSize: "14px", color: "#d32f2f", fontWeight: "bold" },
  profileSection: { marginBottom: "30px" },
  profileCard: {
    display: "flex",
    alignItems: "center",
    background: "linear-gradient(135deg, #e3f2fd, #bbdefb)",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  photoContainer: { marginRight: "20px" },
  sarpanchPhoto: {
    width: "130px",
    height: "130px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "5px solid white",
    boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
  },
  profileInfo: { flex: 1 },
  sarpanchName: { margin: "0 0 10px 0", fontSize: "22px", color: "#1565c0", fontWeight: "bold" },
  motto: { margin: 0, fontSize: "18px", fontStyle: "italic", color: "#1976d2" },
  messageSection: {
    marginBottom: "30px",
    background: "#ffffff",
    padding: "20px",
    borderRadius: "10px",
    borderLeft: "5px solid #42a5f5",
  },
  sectionTitle: {
    color: "#1976d2",
    borderBottom: "2px solid #1976d2",
    paddingBottom: "8px",
    marginTop: 0,
    marginBottom: "15px",
    fontSize: "20px",
  },
  message: { fontSize: "16px", lineHeight: "1.7", margin: 0 },
  successSection: { marginBottom: "30px" },
  intro: { marginBottom: "20px", fontSize: "16px" },
  successGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "15px",
  },
  successCard: {
    background: "#e8f5e9",
    padding: "15px",
    borderRadius: "10px",
    border: "1px solid #a5d6a7",
    textAlign: "center",
  },
  icon: { fontSize: "32px", display: "block", marginBottom: "10px" },
  youthSection: { marginBottom: "30px" },
  youthGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
  },
  youthCard: {
    background: "#fff3e0",
    padding: "15px",
    borderRadius: "10px",
    border: "1px solid #ffcc80",
    textAlign: "center",
  },
  closingSection: {
    background: "linear-gradient(135deg, #fff8e1, #ffecb3)",
    padding: "25px",
    borderRadius: "12px",
    textAlign: "center",
    marginBottom: "30px",
    border: "2px dashed #ffb300",
  },
  closing: { fontSize: "18px", lineHeight: "1.8", margin: 0, color: "#e65100" },
  footer: {
    textAlign: "center",
    paddingTop: "20px",
    borderTop: "1px solid #ddd",
    fontSize: "14px",
    color: "#666",
  },
  link: { color: "#1976d2", textDecoration: "none" },
};

export default Sarpanch;
